import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const EmojiFillSadIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "EmojiFillSad",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16 2C8.27 2 2 8.27 2 16s6.27 14 14 14 14-6.27 14-14S23.73 2 16 2m4.67 9.96a1.87 1.87 0 1 1-.73 3.6h.01a1.867 1.867 0 0 1 .7-3.6zm-9.33 0a1.87 1.87 0 1 1-.73 3.6h.01a1.867 1.867 0 0 1 .7-3.6zm-2.19 9.61c1.83-1.62 4.21-2.65 6.83-2.77H16c2.65.11 5.03 1.14 6.87 2.78h-.01c.18.17.3.42.3.69 0 .23-.08.45-.22.61a.844.844 0 0 1-1.24.09 9.27 9.27 0 0 0-5.67-2.3h-.02c-2.19.09-4.17.93-5.7 2.26h.01a.9.9 0 0 1-.59.22c-.1 0-.2-.02-.29-.05a.92.92 0 0 1-.57-.71s-.01-.1-.01-.15c0-.27.11-.51.29-.69Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16 0C7.18 0 0 7.18 0 16s7.18 16 16 16 16-7.18 16-16S24.82 0 16 0m4.57 10.29c1.26 0 2.29 1.02 2.29 2.29s-1.02 2.29-2.29 2.29-2.29-1.02-2.29-2.29 1.02-2.29 2.29-2.29m-9.14 0c1.26 0 2.29 1.02 2.29 2.29s-1.02 2.29-2.29 2.29-2.29-1.02-2.29-2.29 1.02-2.29 2.29-2.29M23.2 25.06c-.14.06-.29.08-.43.08-.45 0-.88-.27-1.06-.71-.95-2.35-3.19-3.86-5.71-3.86s-4.76 1.51-5.71 3.86c-.23.58-.89.87-1.49.63-.59-.24-.87-.9-.63-1.49 1.3-3.21 4.38-5.28 7.83-5.28s6.53 2.07 7.83 5.28c.24.58-.04 1.25-.63 1.49"
      })
    })
  }));
};
EmojiFillSadIcon.displayName = 'EmojiFillSadIcon';